import React from 'react';
import { Shield, Plus, Trash2 } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Card } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Switch } from '@/components/ui/switch';
import { toast } from 'sonner';
import { descargoService } from '@/lib/api';

export const SettingsDescargos = ({ descargoConfig, setDescargoConfig, newCause, setNewCause }) => {
  const saveConfig = async () => {
    try {
      await descargoService.updateConfig(descargoConfig);
      toast.success('Configuracion de descargos guardada');
    } catch {
      toast.error('Error al guardar configuracion');
    }
  };

  return (
    <Card className="p-6" data-testid="descargos-config-section">
      <h3 className="text-lg font-semibold text-slate-900 mb-2 flex items-center gap-2" style={{fontFamily: 'Manrope'}}><Shield className="w-5 h-5 text-indigo-600" />Modulo de Descargos</h3>
      <p className="text-sm text-slate-600 mb-6">Permite a tus clientes presentar descargos desde el portal. Configura las causas y los datos que necesitas.</p>

      <div className="flex items-center justify-between p-4 bg-indigo-50 border border-indigo-200 rounded-xl mb-6">
        <div><p className="font-medium text-indigo-900">Habilitar Descargos</p><p className="text-sm text-indigo-700">Los clientes podran enviar descargos desde el portal</p></div>
        <Switch checked={descargoConfig.enabled} onCheckedChange={(v) => setDescargoConfig(prev => ({...prev, enabled: v}))} data-testid="descargo-toggle" />
      </div>

      {descargoConfig.enabled && (
        <div className="space-y-6">
          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-3">Datos a solicitar al cliente</h4>
            <div className="space-y-3">
              {[
                { key: 'require_phone', label: 'Telefono' },
                { key: 'require_email', label: 'Email' },
                { key: 'allow_observation', label: 'Observacion (texto libre)' },
                { key: 'allow_attachment', label: 'Adjuntar archivo' }
              ].map(({ key, label }) => (
                <div key={key} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <span className="text-sm text-slate-700">{label}</span>
                  <Switch checked={descargoConfig[key]} onCheckedChange={(v) => setDescargoConfig(prev => ({...prev, [key]: v}))} data-testid={`descargo-${key.replace('_', '-')}`} />
                </div>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-semibold text-slate-800 mb-3">Causas de Descargo</h4>
            <div className="space-y-2 mb-3">
              {descargoConfig.causes.map((cause) => (
                <div key={cause.id || cause.label} className="flex items-center justify-between p-3 bg-slate-50 rounded-lg">
                  <span className="text-sm text-slate-700">{cause.label}</span>
                  <Button variant="ghost" size="sm" className="text-red-500 hover:text-red-700 h-8 w-8 p-0" onClick={() => setDescargoConfig(prev => ({...prev, causes: prev.causes.filter(c => c.label !== cause.label)}))} data-testid={`remove-cause-${cause.label}`}><Trash2 className="w-4 h-4" /></Button>
                </div>
              ))}
              {descargoConfig.causes.length === 0 && <p className="text-sm text-slate-400 italic p-3">No hay causas configuradas. Agrega al menos una.</p>}
            </div>
            <div className="flex gap-2">
              <Input placeholder="Ej: Dominio vendido" value={newCause} onChange={(e) => setNewCause(e.target.value)} onKeyDown={(e) => {
                if (e.key === 'Enter' && newCause.trim()) { setDescargoConfig(prev => ({...prev, causes: [...prev.causes, {label: newCause.trim(), id: Date.now().toString()}]})); setNewCause(''); }
              }} data-testid="new-cause-input" />
              <Button variant="outline" onClick={() => { if (newCause.trim()) { setDescargoConfig(prev => ({...prev, causes: [...prev.causes, {label: newCause.trim(), id: Date.now().toString()}]})); setNewCause(''); } }} data-testid="add-cause-btn"><Plus className="w-4 h-4 mr-1" /> Agregar</Button>
            </div>
          </div>

          <Button className="w-full" data-testid="save-descargo-config" onClick={saveConfig}>Guardar Configuracion de Descargos</Button>
        </div>
      )}

      {!descargoConfig.enabled && (
        <Button className="w-full mt-2" data-testid="save-descargo-config-disabled" onClick={saveConfig}>Guardar</Button>
      )}
    </Card>
  );
};
